module.exports = __webpack_public_path__ + "img/banner1.d297c71c.png";